import { useCallback } from 'react';
import type {
  ArticleHeroMediaAlign,
  ArticleHeroMediaSize,
  ArticleHeroMediaVerticalAlign,
} from '../../../../shared/domain/articleHeroMedia';
import { logArticleHeroMediaLayout } from '../../lib/logArticleHeroMediaLayout';

interface ArticleHeroMediaVideoProps {
  url: string;
  posterUrl?: string;
  size: ArticleHeroMediaSize;
  align: ArticleHeroMediaAlign;
  verticalAlign: ArticleHeroMediaVerticalAlign;
  scale: number;
}

export function ArticleHeroMediaVideo({
  url,
  posterUrl,
  size,
  align,
  verticalAlign,
  scale,
}: ArticleHeroMediaVideoProps) {
  const handleLoadedData = useCallback((event: React.SyntheticEvent<HTMLVideoElement>) => {
    const video = event.currentTarget;
    logArticleHeroMediaLayout('videoLoad', {
      kind: 'video',
      size,
      align,
      verticalAlign,
      scale,
      viewportWidth: video.clientWidth,
      viewportHeight: video.clientHeight,
      naturalWidth: video.videoWidth,
      naturalHeight: video.videoHeight,
    });
  }, [align, verticalAlign, scale, size]);

  return (
    <video
      src={url}
      poster={posterUrl}
      className="article-hero-media__asset"
      autoPlay
      muted
      loop
      playsInline
      preload="auto"
      onLoadedData={handleLoadedData}
    />
  );
}
